import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { withLayout } from "../hoc/with-layout";
import { useQueryClient } from "@tanstack/react-query";
import { CategoryMarketingForm } from "../components/CategoryMarketingForm";
import { useContext, useMemo } from "react";
import { RoleContext } from "../role-provider";

export const CreateCategory = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { defaultLanguage } = useContext(RoleContext);

  const CreateCategoryWithLayout = useMemo(() => {
    return withLayout(() => {
      return (
        <StyledRelativeContainer>
          <Box sx={{ flexGrow: 1, px: 0 }}>
            <Grid container>
              <Grid container mobile={9} sx={{ alignItems: "center", mb: 4 }}>
                <Grid>
                  <Typography variant="h2">New Category</Typography>
                </Grid>
              </Grid>

              <Grid mobile={12}>
                <CategoryMarketingForm
                  editable={true}
                  isLive={false}
                  saveSuccessMessage="Category was created successfully"
                  language={
                    typeof defaultLanguage === "string" ? defaultLanguage : "EN"
                  }
                  setLanguage={() => {}}
                  onSaveSuccess={() => {
                    queryClient.invalidateQueries(["getAllCategoriesList"]);
                    navigate(`/categories`);
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </StyledRelativeContainer>
      );
    }, "New Category");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage]);

  return <CreateCategoryWithLayout />;
};

const StyledRelativeContainer = styled(Grid)({
  margin: 0,
  position: "relative",
});
